module.exports = __webpack_public_path__ + "b37d26afc2f1f301ee34e5fcef11e7b5.svg";